module.exports = __webpack_public_path__ + "fonts/0a191f8.ttf";